import clsx from 'clsx'
import { t } from '@lingui/macro'
import Link from 'next/link'
import { useRouter } from 'next/router'

const PublicationsTabs = ({ variant = '' }) => {
  const tabs = [
    { id: '', label: t`All`, link: { href: '/publications' } },
    { id: 'idpc', label: t`IDPC`, link: { href: '/publications/idpc' } },
    {
      id: 'members',
      label: t`Members`,
      link: { href: '/publications/members' },
    },
  ]

  return (
    <div className="flex flex-row justify-center">
      <div className="w-full max-w-md pb-4 sm:px-0 md:pb-8">
        <ul className="flex justify-center space-x-1 rounded bg-primary-300 p-1">
          {tabs.map((tab) => (
            <li key={`publications-tab-${tab.label}`} className="w-full">
              <Link {...tab.link}>
                <a
                  className={clsx(
                    `block cursor-pointer rounded py-1.5 text-center text-sm font-medium`,
                    'ring-white ring-opacity-60 ring-offset-2 ring-offset-primary-400 focus:outline-none focus:ring-2',
                    variant === tab.id
                      ? 'bg-white shadow'
                      : 'text-primary-100 hover:bg-white/[0.12] hover:text-white'
                  )}
                >
                  {tab.label}
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default PublicationsTabs
